<div class="create-goal-container">
    <div class="header">
        <h1>{{"New Goal" | translate}}</h1>
        <mat-icon (click)="dialogRef.close()" class="close-button" mat-dialog-close>
            clear
        </mat-icon>
    </div>

    <!-- Form Element Here -->
    <app-goal-form 
        (formSubmit)="onConfirmClick($event)" 
        (formCancel)="onCancelClick()"
        action="confirm"
    >
    </app-goal-form>
    <!-- End of Form Element -->
    
</div>